// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-goods-info {
  display: flex;
  direction: rtl;
  justify-content: space-around;
}

.number-good-item {
  margin-top: 20px;
}

mat-label {
  font-size: small;
}

mat-option {
  font-size: small;
}

.box-data {
  border-radius: 4px;
  font-size: small;
  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);
  margin-top: 20px;
  margin-right: 10px;
  margin-left: 10px;
}

.parent-item {
  display: flex;
  direction: rtl;
  justify-content: space-around;
}

.items-value {
  direction: rtl;
  margin: auto;
}

mat-form-field {
  width: 99%;
}

.hsCode-input {
  direction: rtl;
  text-align: right;
}

.hsCode-option {
  display: flex;
  justify-content: right;
}

.hsCode_text {
  direction: rtl;
  width: -moz-fit-content;
  width: fit-content;
  overflow: scroll;
}

input#mat-input-8 {
  font-size: small;
}

.check-box-data {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.title-goods-add {
  color: #628d9d;
  font-size: medium;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 10px;
}

.wrapper {
  margin: 10px;
}
.wrapper .name {
  color: #383a3e;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.wrapper .end {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row-reverse;
}
.wrapper .end .button {
  border-radius: 4px;
  padding: 5px 0;
  width: 50%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: small;
}
.wrapper .end .button:nth-child(1) {
  background: #628d9d;
}
.wrapper .end .button:nth-child(2) {
  background: white;
  border: 1px solid #628d9d;
  color: #628d9d;
}

.no-good {
  text-align: center;
  border-radius: 4px;
  font-size: small;
  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);
  margin: 20px;
  padding: 20px;
}

.text-add-goods {
  color: #628d9d;
  font-size: medium;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 10px;
  text-align: center;
}

.btns {
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.button-quote-stepper {
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/quote-request/quote-goods-info/quote-goods-info.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/quote-request/quote-goods-info/quote-goods-info.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADEA;EACI,gBAAA;ACCJ;;ADGA;EACI,gBAAA;ACAJ;;ADGA;EACI,kBAAA;EACA,gBAAA;EACA,4HAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ACAJ;;ADGA;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ACAJ;;ADGA;EACI,cAAA;EACA,YAAA;ACAJ;;ADGA;EACI,UAAA;ACAJ;;ADGA;EACI,cAAA;EACA,iBAAA;ACAJ;;ADGA;EACI,aAAA;EACA,sBAAA;ACAJ;;ADGA;EACI,cAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,gBAAA;ACAJ;;ADGA;EACI,aAAA;EACA,6BAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;ACAJ;;ADGA;EACI,YAAA;ACAJ;ADEI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;ACAR;ADGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;ACDR;ADGQ;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ACDZ;ADQY;EACI,mBAAA;ACNhB;ADSY;EACI,iBAAA;EACA,yBAAA;EACA,cAAA;ACPhB;;ADaA;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4HAAA;EACA,YAAA;EACA,aAAA;ACVJ;;ADaA;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;ACVJ;;ADaA;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;ACVJ;;ADYA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;ACTJ","sourcesContent":[".parent-goods-info {\r\n    display: flex;\r\n    direction: rtl;\r\n    justify-content: space-around;\r\n}\r\n\r\n.number-good-item {\r\n    margin-top: 20px;\r\n}\r\n\r\nmat-label {\r\n    font-size: small;\r\n\r\n}\r\n\r\nmat-option {\r\n    font-size: small;\r\n}\r\n\r\n.box-data {\r\n    border-radius: 4px;\r\n    font-size: small;\r\n    box-shadow: 0 0 2.7907px rgb(0 0 0 / 0%), 0 2.7907px 2.7907px rgb(0 0 0 / 0%), 0px 1.39535px 4.18606px rgb(0 0 0 / 16%);\r\n    margin-top: 20px;\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.parent-item {\r\n    display: flex;\r\n    direction: rtl;\r\n    justify-content: space-around;\r\n}\r\n\r\n.items-value {\r\n    direction: rtl;\r\n    margin: auto;\r\n}\r\n\r\nmat-form-field {\r\n    width: 99%;\r\n}\r\n\r\n.hsCode-input {\r\n    direction: rtl;\r\n    text-align: right;\r\n}\r\n\r\n.hsCode-option {\r\n    display: flex;\r\n    justify-content: right;\r\n}\r\n\r\n.hsCode_text {\r\n    direction: rtl;\r\n    width: fit-content;\r\n    overflow: scroll;\r\n}\r\n\r\ninput#mat-input-8 {\r\n    font-size: small;\r\n}\r\n\r\n.check-box-data {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    margin-top: 20px;\r\n}\r\n\r\n.title-goods-add {\r\n    color: #628d9d;\r\n    font-size: medium;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.wrapper {\r\n    margin: 10px;\r\n\r\n    .name {\r\n        color: #383a3e;\r\n        font-size: 16px;\r\n        font-weight: bold;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .end {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        flex-flow: row-reverse;\r\n\r\n        .button {\r\n            border-radius: 4px;\r\n            padding: 5px 0;\r\n            width: 50%;\r\n            text-align: center;\r\n            cursor: pointer;\r\n            color: #fff;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            font-size: small;\r\n\r\n            // ion-icon {\r\n            //     font-size: medium;\r\n            //     margin-left: 5px;\r\n            // }\r\n\r\n            &:nth-child(1) {\r\n                background: #628d9d;\r\n            }\r\n\r\n            &:nth-child(2) {\r\n                background: white;\r\n                border: 1px solid #628d9d;\r\n                color: #628d9d;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.no-good {\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    font-size: small;\r\n    box-shadow: 0 0 2.7907px rgb(0 0 0 / 0%), 0 2.7907px 2.7907px rgb(0 0 0 / 0%), 0px 1.39535px 4.18606px rgb(0 0 0 / 16%);\r\n    margin: 20px;\r\n    padding: 20px;\r\n}\r\n\r\n.text-add-goods{\r\n    color: #628d9d;\r\n    font-size: medium;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    margin-right: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.btns {\r\n    margin-left: 20px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n.button-quote-stepper{\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}",".parent-goods-info {\n  display: flex;\n  direction: rtl;\n  justify-content: space-around;\n}\n\n.number-good-item {\n  margin-top: 20px;\n}\n\nmat-label {\n  font-size: small;\n}\n\nmat-option {\n  font-size: small;\n}\n\n.box-data {\n  border-radius: 4px;\n  font-size: small;\n  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);\n  margin-top: 20px;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n.parent-item {\n  display: flex;\n  direction: rtl;\n  justify-content: space-around;\n}\n\n.items-value {\n  direction: rtl;\n  margin: auto;\n}\n\nmat-form-field {\n  width: 99%;\n}\n\n.hsCode-input {\n  direction: rtl;\n  text-align: right;\n}\n\n.hsCode-option {\n  display: flex;\n  justify-content: right;\n}\n\n.hsCode_text {\n  direction: rtl;\n  width: fit-content;\n  overflow: scroll;\n}\n\ninput#mat-input-8 {\n  font-size: small;\n}\n\n.check-box-data {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 20px;\n}\n\n.title-goods-add {\n  color: #628d9d;\n  font-size: medium;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  margin-right: 10px;\n}\n\n.wrapper {\n  margin: 10px;\n}\n.wrapper .name {\n  color: #383a3e;\n  font-size: 16px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n.wrapper .end {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-flow: row-reverse;\n}\n.wrapper .end .button {\n  border-radius: 4px;\n  padding: 5px 0;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: small;\n}\n.wrapper .end .button:nth-child(1) {\n  background: #628d9d;\n}\n.wrapper .end .button:nth-child(2) {\n  background: white;\n  border: 1px solid #628d9d;\n  color: #628d9d;\n}\n\n.no-good {\n  text-align: center;\n  border-radius: 4px;\n  font-size: small;\n  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);\n  margin: 20px;\n  padding: 20px;\n}\n\n.text-add-goods {\n  color: #628d9d;\n  font-size: medium;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  margin-right: 10px;\n  text-align: center;\n}\n\n.btns {\n  margin-left: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.button-quote-stepper {\n  margin-right: 10px;\n  margin-left: 10px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
